import { Cpu, HardDrive, Layers, Server } from 'lucide-react';
import { Card, CardBody } from '../ui/Card';
import type { DockerHostSummary } from '../../types';

export function HostSummaryCard({ host }: { host: DockerHostSummary }) {
  return (
    <Card>
      <CardBody className="grid grid-cols-2 gap-4 sm:grid-cols-4">
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-pulse-50 text-pulse-600 dark:bg-pulse-900/30 dark:text-pulse-300">
            <Server size={16} />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 dark:text-white">{host.serverVersion}</p>
            <p className="text-xs text-slate-400">Docker Engine</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            <Cpu size={16} />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 dark:text-white">{host.architecture}</p>
            <p className="text-xs text-slate-400">{host.os}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            <Layers size={16} />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 dark:text-white">{host.imagesCount}</p>
            <p className="text-xs text-slate-400">Images</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-slate-100 text-slate-500 dark:bg-slate-800 dark:text-slate-400">
            <HardDrive size={16} />
          </div>
          <div>
            <p className="text-sm font-semibold text-slate-900 dark:text-white">{host.containersTotal}</p>
            <p className="text-xs text-slate-400">Containers</p>
          </div>
        </div>
      </CardBody>
    </Card>
  );
}
